<template>
  <RevCardCarousel
    v-if="shouldDisplayBlock"
    class="[&_li]:rounded-lg [&_li]:w-[223px] [&_li]:bg-[url('/img/product/verified-refurbished/fingerprint.svg'),_url('/img/product/verified-refurbished/holo.avif')] [&_li]:bg-blend-overlay [&_li]:[background-attachment:scroll,fixed] [&_li]:supports-[(-webkit-touch-callout:none)]:[background-attachment:scroll]"
    :next-alternative-text="i18n(translations.nextSlideText)"
    :prev-alternative-text="i18n(translations.prevSlideText)"
    :subtitle="checkpoints.subtitle"
    :title="checkpoints.title"
  >
    <Card
      v-for="(checkpoint, index) in checkpoints.items"
      :key="checkpoint.text"
      :checkpoint
      :index
      @click="onCardClick(index)"
    />
  </RevCardCarousel>
  <ClientOnly>
    <VerifiedRefurbishedCarouselModal :checkpoints :opened-index />
  </ClientOnly>
</template>

<script setup lang="ts">
import { useRuntimeConfig } from '#imports'
import { computed, ref } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'
import { RevCardCarousel } from '@ds/components/CardCarousel'

import type { GetVerifiedRefurbishCarouselResponse } from '~/api/product-page/types'

import translations from './VerifiedRefurbishedCarousel.translations'
import Card from './components/Card/Card.vue'
import VerifiedRefurbishedCarouselModal from './components/VerifiedRefurbishedCarouselModal/VerifiedRefurbishedCarouselModal.vue'

const props = defineProps<{
  categoryId: string
  checkpoints: GetVerifiedRefurbishCarouselResponse
}>()

const { countryCode } = useMarketplace().market
const config = useRuntimeConfig()
const i18n = useI18n()

const openedIndex = ref(0)

const shouldDisplayBlock = computed(() => {
  return (
    props.checkpoints.items.length > 0 &&
    config.public.FF_ENABLE_VERIFIED_REFURBISHED_LINK_PP?.includes(countryCode)
  )
})

function onCardClick(index: number) {
  openedIndex.value = index
}
</script>
